import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/portal-category', { params });
  },
  detail(id) {
    return axios.get(`/v1/portal-category/detail/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/portal-category/${id}`, params);
  },
  create(data) {
    return axios.post('/v1/portal-category', data);
  },
  delete(id) {
    return axios.delete(`/v1/portal-category/${id}`);
  },
  getDoc(params = {}) {
    return axios.get('/v1/portal-category/current-guideline', { params });
  },
  uploadDoc(data) {
    return axios.post('/v1/portal-category/upload', data);
  }
};
